import {useEffect, useState} from "react";
import {useShopStore} from "@/entities/shop";
import {Breadcrumbs} from "@/shared/ui/Breadcrumbs";
import {ShopMap} from "@/widgets/shops-map";
import BaseLayout from "@/Layouts/BaseLayout";
import styles from "./ShopsPage.module.scss";

const Index = (props) => {
    const {h1, mapsData = {}, isMobile = false} = props;
    const {mapDefaultState} = mapsData;

    const [showMap, setShowMap] = useState(false);

    const shops = useShopStore(s => s.shops);
    const shopType = useShopStore(s => s.shopType);
    const query = useShopStore(s => s.query);
    const loading = useShopStore(s => s.loading);
    const fetchShops = useShopStore(s => s.actions.fetchShops);
    const changeShopType = useShopStore(s => s.actions.changeShopType);
    const setQuery = useShopStore(s => s.actions.setQuery);

    /**
     * Получение магазинов
     */
    useEffect(() => {
        fetchShops().then(() => setShowMap(true));
    }, []);

    return (
        <BaseLayout {...props}>
            <div className={`globalContainer`}>
                <div className={styles.pageContainer}>
                    <Breadcrumbs
                        items={[
                            {label: "Главная", href: "/"},
                            {label: h1},
                        ]}
                    />
                    <h1 className={styles.h1}>{h1}</h1>
                    {showMap && (
                        <ShopMap
                            shops={shops}
                            shopType={shopType}
                            query={query}
                            loading={loading}
                            setQuery={setQuery}
                            fetchShops={fetchShops}
                            mapDefaultState={mapDefaultState}
                            changeShopType={changeShopType}
                            isMobile={isMobile}
                        />
                    )}
                </div>
            </div>
        </BaseLayout>
    );
}

export default Index;
